import { IntercomProvider } from "react-use-intercom"
import { BrowserRouter } from "react-router-dom"
import { HMSRoomProvider } from "@100mslive/react-sdk"
import { HelmetProvider, Helmet } from "react-helmet-async"
import { UserContextProvider } from "../context/userContext"
import { CommonFunctionProvider } from "../context/commonFunctionContext"
import { NotificationCtxProvider } from "../context/notificationContext"
import { SubscriptionProvider } from "../context/subscriptionContext"
import { LoadingProvider } from "../context/loadingContext"
import { AuthProvider } from "./auth/context"
import GoogleAuthProviderWrapper from "../context/GoogleAuthProvider"
import { ToastProvider } from "../hooks/useToast"

export function Providers({ children }: { children: React.ReactNode }) {
  const isDevelopment = process.env.REACT_APP_USER_ENVIRONMENT !== "production"

  return (
    <HelmetProvider>
      {isDevelopment && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}
      <BrowserRouter>
        <HMSRoomProvider>
          <LoadingProvider>
            <IntercomProvider
              appId={process.env.REACT_APP_INTERCOM || ""}
              autoBoot
            >
              <UserContextProvider>
                <ToastProvider>
                  <CommonFunctionProvider>
                    <GoogleAuthProviderWrapper>
                      <AuthProvider>
                        <SubscriptionProvider>
                          <NotificationCtxProvider>
                            {children}
                          </NotificationCtxProvider>
                        </SubscriptionProvider>
                      </AuthProvider>
                    </GoogleAuthProviderWrapper>
                  </CommonFunctionProvider>
                </ToastProvider>
              </UserContextProvider>
            </IntercomProvider>
          </LoadingProvider>
        </HMSRoomProvider>
      </BrowserRouter>
    </HelmetProvider>
  )
}